import React, { useContext, useState } from "react";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import AuthInputText from "../../components/AuthInput";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "../../service/context/tokencontent";
import { validationSchema } from "../../service/validation/gstVerification";
import { ApiService } from "../../service/api.service";
import { AUTH_URL } from "../../common/common";

const GSTVerification = () => {
  const { setToken, token } = useContext(TokenContext)!;
  const apiService = new ApiService();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      gstNumber: "",
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: any) => {
    try {
      let newData = {
        type: "Gst",
        gstNumber: data.gstNumber,
      }
      const response = await apiService.postApi(`${AUTH_URL}/business/verify-route`, newData)
      // console.log(response, "response");
      if (response.status === "200") {
        localStorage.setItem("gst-mot", data.gstNumber)
        navigate("/gst-details")

      }
    } catch (error) {
      console.error("GST Verification Error:", error);
      alert("Failed to verify GST Number. Please try again.");
    }
  };

  const gstNumberValue = watch("gstNumber", "");

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        {/* <div className="bg-[#D9D9D9] rounded-[21.25px] w-full h-full"></div> */}
        <div className="w-full h-full">
          <div className="md:mx-[8rem] my-[2rem] m-6">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <br />
            <p className="font-[700] text-[20px] font-poppins leading-[41.33px] track-[1%]">
              Welcome aboard 👋
            </p>
            <p className="font-[400] font-poppins text-[16px] leading-[36.73px] track-[1%] text-[#313957]">
              Business KYC
            </p>
            <br />
            {/* Form */}
            <form onSubmit={handleSubmit(onSubmit)}>
              <AuthInputText
                label="GST Number"
                value={gstNumberValue}
                errors={errors}
                placeholder="Enter GST Number"
                autoComplete="one-time-code"
                name="gstNumber"

                type="text"
                maxLength={15}
                toUpperCase={true}
                register={register}
              />

              {/* Submit button */}
              <div className="mx-[20px]">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="mt-4 p-2 w-full h-[50px] font-[400] text-[16px] leading-[22.96px] tracking-[1%] bg-[#444FBD] rounded-[20px] text-white rounded"
                >
                  {isSubmitting ? "Verifying..." : "Verify"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </AuthContainer>
  );
};


export default GSTVerification;
